module.exports = __webpack_public_path__ + "src/img/artist/name01.svg?18a9a02127b1d7352897eac1af6dfd8f";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name01.svg
// module id = 137
// module chunks = 0